import { render, staticRenderFns } from "./CustomFieldModalTableView.vue?vue&type=template&id=a5bde3f2&scoped=true"
import script from "./CustomFieldModalTableView.vue?vue&type=script&lang=ts"
export * from "./CustomFieldModalTableView.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldModalTableView.vue?vue&type=style&index=0&id=a5bde3f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bde3f2",
  null
  
)

export default component.exports